export default __webpack_public_path__ + "static/media/cp_geo_ax.afc5abc1.svg";